// extracted by mini-css-extract-plugin
export default {"formWrap":"Modal_formWrap__J3liz"};